import { Component, OnInit } from '@angular/core';
import { CommonService } from '@tech-services/common.service';
import { InitcontributionService } from '@tech-services/initcontribution.service';
import { SessionService } from '@tech-services/session.service';
import { Any } from 'json2typescript';
import { of, Subject } from 'rxjs';
import { takeUntil, zipAll } from 'rxjs/operators';
import {
  SimulationObjInterface,
  profileAnalisysInterface
} from '@techrules/portallib';
@Component({
  selector: 'tech-simulation-init-distribution',
  templateUrl: './simulation-init-distribution.component.html',
  styleUrls: ['./simulation-init-distribution.component.scss'],
})
export class SimulationInitDistributionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();

  constructor(
    private initcontributionService: InitcontributionService,
    private commonService: CommonService,
    private session: SessionService
  ) {}

  ngOnInit() {
    this.commonService.clientData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        setTimeout(() => {
          this.initcontributionService.simulationObj$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((data: SimulationObjInterface) => {
              if (data.ProfileId !== undefined) {
                this.initcontributionService
                  .getProfileAnalysis()
                  .pipe(takeUntil(this.unsubscribe$))
                  .subscribe((res: profileAnalisysInterface) => {
                    if (Object.entries(res).length !== 0) {
                      this.initcontributionService.profileAnalysisSource.next(
                        res
                      );
                    }
                  });
              }
            });
        });
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
